export default "__VITE_ASSET__oU3Cg5BO__"